<form [formGroup]="agreementForm">
    <app-form-section formGroupName="details">
        <app-form-row>
            <app-form-group class="report-container">
                <div class="box">
                    <app-form-row-header
                        [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_NOTES' | translate"
                        icon="edit_note"
                    />
                    <div class="form">
                        <app-form-row>
                            <app-form-group>
                                <app-agreement-notes-reminders [noteRemindersForm]="noteReminderForm">
                                </app-agreement-notes-reminders>
                            </app-form-group>
                        </app-form-row>
                    </div>
                </div>
            </app-form-group>
            <app-form-group class="report-container">
                <div class="box">
                    <app-form-row-header
                        [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_ATTACHMENT' | translate"
                        icon="attach_file"
                    />
                    <div class="form">
                        <app-form-row>
                            <app-form-group>
                                <app-agreement-attachment
                                    [attachmentForm]="agreementForm.controls.attachments"
                                    (fileDialogStateChange)="onFileDialogStateChange($event)"
                                ></app-agreement-attachment>
                            </app-form-group>
                        </app-form-row>
                    </div>
                </div>
            </app-form-group>
        </app-form-row>
    </app-form-section>
</form>
